import styled from 'styled-components';

export const RelatoriosContainer = styled.div`
  width: 100%;
`;

export const RelatoriosTitle = styled.h1`
  margin-bottom: 24px;
  color: ${({ theme }) => theme.primaryColor};
  font-size: 24px;
`;

export const RelatoriosContent = styled.div`
  background-color: ${({ theme }) => theme.white};
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 24px;
`;

export const RelatoriosInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  p {
    margin: 0;

    &:first-child {
      font-size: 18px;
      font-weight: 500;
    }
  }
`;

export const FilterContainer = styled.div`
  display: flex;
  gap: 16px;
  margin-bottom: 24px;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const FilterGroup = styled.div`
  display: flex;
  justify-content:center;
  gap: 16px;
  flex-grow: 1;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 16px;
`;

export const TableContainer = styled.div`
  margin-top: 24px;
  overflow-x: auto;
`;

export const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 24px;
  width: 100%;
  max-width: 800px;
`;

export const ModalImage = styled.img`
  max-width: 100%;
  max-height: 80vh;
  object-fit: contain;
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 16px;

  h3 {
    margin: 0;
  }
`;

export const ImagePlaceholder = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 300px;
  background-color: ${({ theme }) => theme.lightGray};
  color: ${({ theme }) => theme.gray};
  border-radius: 4px;
`;

export const ErrorContainer = styled.div`
  color: ${({ theme }) => theme.dangerColor};
  margin-top: 16px;
  padding: 12px;
  background-color: ${({ theme }) => theme.dangerLightColor || '#ffeeee'};
  border-radius: 4px;
`;

export const ActionLink = styled.span`
  color: ${({ theme }) => theme.primaryColor};
  cursor: pointer;
  text-decoration: underline;

  &:hover {
    color: ${({ theme }) => theme.primaryDarkColor || '#0056b3'};
  }
`;
